import { ICreateAutoparkRequest } from '../services/autopark.service';

export interface AutoparkValidationErrors {
  fullnameEmployee?: string;
  fullnameOwner?: string;
  phone?: string;
  index?: string;
  tradeName?: string;
  legalName?: string;
  email?: string;
  externalId?: string;
  inn?: string;
  kpp?: string;
  bik?: string;
  bankName?: string;
  currentAccount?: string;
  actualAddress?: string;
  legalAddress?: string;
  ogrn?: string;
}

// Валидация email (из регистрации)
export const validateEmail = (email: string): string => {
  if (!email.trim()) {
    return 'Email обязателен';
  }
  if (!/\S+@\S+\.\S+/.test(email)) {
    return 'Некорректный адрес электронной почты';
  }
  return '';
};

// Валидация телефона (упрощенная, так как PhoneInput уже валидирует)
export const validatePhone = (phone: string): string => {
  if (!phone.trim()) {
    return 'Телефон обязателен';
  }
  // Полноту номера проверяет PhoneInput (isValid в onChangeValue)
  return '';
};

// Валидация ИНН (должен быть 10 символов)
export const validateInn = (inn: string): string => {
  if (!inn.trim()) {
    return 'ИНН обязателен';
  }
  if (!/^\d{10}$/.test(inn)) {
    return 'ИНН должен состоять из 10 цифр';
  }
  return '';
};

// Валидация ОГРН (должен быть 13 символов)
export const validateOgrn = (ogrn: string): string => {
  if (!ogrn.trim()) {
    return 'ОГРН обязателен';
  }
  if (!/^\d{13}$/.test(ogrn)) {
    return 'ОГРН должен состоять из 13 цифр';
  }
  return '';
};

// Валидация КПП
export const validateKpp = (kpp: string): string => {
  if (!kpp.trim()) {
    return 'КПП обязателен';
  }
  if (!/^\d{9}$/.test(kpp)) {
    return 'КПП должен состоять из 9 цифр';
  }
  return '';
};

// Валидация БИК
export const validateBik = (bik: string): string => {
  if (!bik.trim()) {
    return 'БИК обязателен';
  }
  if (!/^\d{9}$/.test(bik)) {
    return 'БИК должен состоять из 9 цифр';
  }
  return '';
};

// Валидация расчетного счета
export const validateCurrentAccount = (account: string): string => {
  if (!account.trim()) {
    return 'Расчетный счет обязателен';
  }
  if (!/^\d{20}$/.test(account)) {
    return 'Расчетный счет должен состоять из 20 цифр';
  }
  return '';
};

// Валидация обязательного поля
export const validateRequired = (value: string, fieldName: string): string => {
  if (!value.trim()) {
    return `${fieldName} обязательно`;
  }
  return '';
};

// Валидация всей формы автопарка
export const validateAutoparkForm = (data: ICreateAutoparkRequest): AutoparkValidationErrors => {
  const errors: AutoparkValidationErrors = {};

  errors.fullnameEmployee = validateRequired(data.fullnameEmployee, 'ФИО сотрудника');
  errors.fullnameOwner = validateRequired(data.fullnameOwner, 'ФИО владельца');
  // phone валидируется отдельно в PhoneInput компоненте
  errors.index = validateRequired(data.index, 'Индекс');
  errors.tradeName = validateRequired(data.tradeName, 'Торговое наименование');
  errors.legalName = validateRequired(data.legalName, 'Юридическое наименование');
  errors.email = validateEmail(data.email);
  errors.inn = validateInn(data.inn);
  errors.kpp = validateKpp(data.kpp);
  errors.bik = validateBik(data.bik);
  errors.bankName = validateRequired(data.bankName, 'Название банка');
  errors.currentAccount = validateCurrentAccount(data.currentAccount);
  errors.actualAddress = validateRequired(data.actualAddress, 'Фактический адрес');
  errors.legalAddress = validateRequired(data.legalAddress, 'Юридический адрес');
  errors.ogrn = validateOgrn(data.ogrn);

  // Удаляем пустые ошибки
  Object.keys(errors).forEach((key) => {
    if (!errors[key as keyof AutoparkValidationErrors]) {
      delete errors[key as keyof AutoparkValidationErrors];
    }
  });

  return errors;
};
